module.exports = __webpack_public_path__ + "static/media/CloseIconBlue.5296e831.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CloseIconBlue.svg
// module id = 1178
// module chunks = 0